import React, {Component} from 'react';
import {connect} from 'react-redux';
import axiosInstance from '../../utils/axios-instance';

class StripePaymentResult extends Component {
    state = {
        loading: true,
        sessionData: null,
        error: null,
    };

    componentDidMount() {
        const params = new URLSearchParams(this.props.location.search);
        const sessionId = params.get('session_id');

        if (!sessionId) {
            this.setState({loading: false, error: 'No session ID provided.'});
            return;
        }

        this.fetchSessionStatus(sessionId);
    }

    fetchSessionStatus = async (sessionId) => {
        try {
            const response = await axiosInstance.get(`/payment-provider/stripe/checkout/session/${sessionId}/status`);
            this.setState({loading: false, sessionData: response.data});
        } catch (err) {
            this.setState({loading: false, error: 'Unable to retrieve payment status. Please try again later.'});
        }
    };

    renderContent() {
        const {loading, sessionData, error} = this.state;

        if (loading) {
            return (
                <div style={{textAlign: 'center'}}>
                    <div className="mb-4">
                        <i className="fas fa-spinner fa-spin text-muted" style={{fontSize: '4rem'}}></i>
                    </div>
                    <h4 className="text-muted">Verifying your payment...</h4>
                </div>
            );
        }

        if (error) {
            return (
                <div style={{textAlign: 'center'}}>
                    <div className="mb-4">
                        <i className="fas fa-exclamation-triangle text-warning" style={{fontSize: '4rem'}}></i>
                    </div>
                    <h4 className="text-danger">{error}</h4>
                    <div className="mt-4">
                        <p className="text-muted">
                            <i className="fas fa-info-circle mr-1"></i>
                            You can safely close this tab now.
                        </p>
                    </div>
                </div>
            );
        }

        const isPaid = sessionData && sessionData.paymentStatus === 'paid';
        const isACH = sessionData && sessionData.paymentMethodTypes && sessionData.paymentMethodTypes.includes('us_bank_account');
        const isProcessing = sessionData && (sessionData.paymentIntentStatus === 'processing' || isACH);
        const isSuccess = isPaid || isProcessing;

        return (
            <div style={{textAlign: 'center'}}>
                <div className="mb-4">
                    <i className={'fas fa-' + (isSuccess ? 'check-circle text-success' : 'times-circle text-danger')}
                       style={{fontSize: '4rem'}}></i>
                </div>
                <h4 className={isSuccess ? 'text-success' : 'text-danger'}>
                    {isSuccess ? 'Payment Complete' : 'Payment Failed'}
                </h4>
                <p className="mt-3">
                    {isPaid
                        ? 'Your payment has been processed successfully. Thank you!'
                        : isProcessing
                            ? 'Thank you! Your payment transaction is completed.'
                            : 'We were unable to process your payment. Please try again or contact support.'}
                </p>

                {isSuccess && sessionData && (
                    <div className="mt-4">
                        <p className="text-muted mb-1">
                            <small>Amount: ${sessionData.amountTotal?.toFixed(2)} {sessionData.currency?.toUpperCase()}</small>
                        </p>
                        <p className="text-muted mb-1">
                            <small>Account: {sessionData.accountNumber}</small>
                        </p>

                        <p className="text-muted mb-1">
                            <small>Transaction ID: {sessionData.paymentIntentId}</small>
                        </p>


                    </div>
                )}

                <div className="mt-4">
                    <p className="text-muted">
                        <i className="fas fa-info-circle mr-1"></i>
                        You can safely close this tab now.
                    </p>
                </div>
            </div>
        );
    }

    render() {
        const fullPageStyle = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: 1,
            width: '100%',
            padding: '2rem',
            backgroundColor: '#ffffff',
        };

        return (
            <div className="cp-page" style={fullPageStyle}>
                {this.renderContent()}
            </div>
        );
    }
}

StripePaymentResult.propTypes = {};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(StripePaymentResult);
